import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-surface-accent" data-id="element-99" data-mp="4vrzlvp3q9pt">
      <div className="max-w-3xl mx-auto" data-id="element-100" data-mp="9ttjujy9kf2v">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl p-8 md:p-12 shadow-lg text-center border-2 border-primary/20" data-id="element-101" data-mp="9srx3i7vy45b">
          <ShieldCheckIcon className="w-16 h-16 mx-auto mb-6 text-primary" data-id="element-102" data-mp="skcd7kqu0k1u" />

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-103" data-mp="xjxkqjk2i0q6">
            🛡️ Garantía 7 días sin preguntas
          </h2>

          <p className="text-lg text-gray-700 mb-6" data-id="element-104" data-mp="12k35dfrx6myr">
            Abre los 12 Tomos. Revisa los 6 Bonus. Úsalos en tu clase.
          </p>

          <p className="text-xl font-semibold text-gray-900 mb-6" data-id="element-105" data-mp="17g0oftuki7f8">
            Si no es lo que esperabas → 100% de devolución. Sin preguntas. Sin
            formularios. Sin drama.
          </p>

          <div className="inline-block bg-surface-accent text-primary px-6 py-3 rounded-lg font-bold" data-id="element-106" data-mp="20ux30ccvfr7v">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </motion.div>
      </div>
    </section>;
}